/** IoT Manager — plumbing rooms (gateway-local). */
export const plumbingRoomEndpoints = {
  list: '/v1/iot-manager/plumbing-rooms',
  one: (id: string) => `/v1/iot-manager/plumbing-rooms/${id}`,
} as const;
